const activity = {
  activity: "פעילות", // translated
  activities: "פעילויות", // translated
  dates: "תאריכים", // translated
  location: "מקום", // translated
  languages: "שפות", // translated
  categories: "קטגוריות", // translated
  ticketOption: "אפשרות כרטיס", // translated
  numberOfRatings: "מספר דירוגים", // translated
  meetingPointInfo: "מידע על נקודת מפגש", // translated
  meetingPoint: "נקודת מפגש", // translated
  meetingPoints: "נקודות מפגש", // translated
  providedBy: "המסופק על ידי", // translated
  expirationDate: "תאריך תפוגה", // translated
  groupSize: "גודל קבוצה", // translated
  features: "מאפיינים", // translated
  basedOn: "מבוסס על", // translated
  reviewsFromVerCustomers: "ביקורות מלקוחות מאומתים", // translated
  excellent: "מְעוּלֶה", // translated
  great: "גדול", // translated
  average: "מְמוּצָע", // translated
  poor: "עני", // translated
  bad: "רַע", // translated
  onlyBookedCustomersTooltip: "רק לקוחות שהזמינו פעילות זו יכולים להשאיר חוות דעת", // translated
  noReviewsYet: "כרגע, אין ביקורות על פעילות זו.", // translated
  backToActivitiesList: "חזרה לרשימת הפעילויות", // translated
  getPrices: "לקבל מחירים", // translated
  availabilityAndPrices: "זמינות ומחירים", // translated
  ticketOptions: "אפשרויות כרטיסים", // translated
  ticketInfo: "מידע על כרטיסים", // translated
  selectYourTickets: "בחר את הכרטיסים שלך", // translated
  product: "מוצר", // translated
  total: "total", // translated
  slot: "חָרִיץ", // translated
  language: "שפה", // translated
  tickets: "כרטיסים", // translated
  ticketsFor: "כרטיסים עבור", // translated
  previousStep: "צעד קודם", // translated
  onlyAvailableInEnglish: "זמין רק באנגלית", // translated
  guest: "אוֹרֵחַ", // translated
  leadGuest: "אורח מוביל", // translated
  adult: "מְבוּגָר", // translated
  child: "יֶלֶד", // translated
  pleaseSelectAdult: "אנא בחר מבוגר אחד לפחות", // translated
  notAvailableActivity: "מוצר זה אינו זמין", // translated
  required: "נדרש", // translated
  pickupPoint: "נקודת איסוף", // translated
  pickupPoints: "נקודות איסוף", // translated
  ticketType: "סוג כרטיס", // translated
  anonymous: "בעילום שם", // translated
  printedVoucher: "שובר מודפס מתקבל", // translated
  mobileVoucher: "שובר נייד מתקבל", // translated
  mixedVoucher: "שובר נייד או מודפס מתקבל", // translated
  safetyMeasures: "אמצעי בטיחות שהופעלו", // translated
  doThisBecause: "תעשה את זה בגלל", // translated
  safetyInfo: "מידע בטיחות", // translated
  reviewsHighestFirst: "מספר ביקורות (הגבוה ביותר ראשון)", // translated
  bookingFee: "דמי הזמנה", // translated
  startDate: "תאריך התחלה", // translated
  endDate: "תאריך סיום", // translated
  cancellationDeadlineAndFees: "מועד אחרון לביטול ועמלות", // translated
  resetTickets: "אפס כרטיסים", // translated
  clickResetBtn: "לחץ על כפתור האיפוס כדי להתחיל שוב את הבחירה שלך", // translated
  instantConfirmation: "אישור מיידי", // translated
};

export default activity;
